module.exports = __webpack_public_path__ + "img/logo4.63864e61.webp";